module.exports = __webpack_public_path__ + "img/btn_return.72a04793.png";